import { Link } from "react-router";
import { routes } from "../../app/routes";
import "./footer.css";

/** "by Forlais", with the official logo file, plus the quiet links every page needs. */
export function ByForlais() {
  return (
    <footer className="site-footer">
      <a className="site-footer__maker" href="https://forlais.com" rel="noopener">
        <span className="site-footer__by">by</span>
        <img src="/brand/forlais-white.svg" alt="Forlais" width={1435} height={279} />
      </a>
      <Link className="site-footer__link" to={routes.privacy()}>
        Privacy
      </Link>
    </footer>
  );
}
